module.exports = __webpack_public_path__ + "static/media/ad-3.8cc0c6ed.png";